import api from '../../api/moviedb';
import * as types from '../mutation-types';
import utils from '../../utils';

const state = {
  main: null,
  movies: [],
  block: 3, // how many movies are retrieved every request
  requests: 1,
};

const mutations = {
  [types.SET_RECOMMENDED_MOVIES](state, movies) {
    state.movies = movies;
  },
  [types.SET_RECOMMENDED_MAIN_MOVIE](state, main) {
    state.main = main;
  },
  [types.REMOVE_RECOMMENDED_MOVIES](state) {
    state.movies = [];
  },
  [types.INCREASE_REQUEST_RECOMMENDED_MOVIES](state) {
    state.requests += 1;
  },
  [types.RESET_REQUEST_RECOMMENDED_MOVIES](state) {
    state.requests = 1;
  },
};

const actions = {
  recommendMovies: ({ commit }, movie) => {
    if (state.main === null || state.main.id !== movie.id) {
      commit(types.SET_RECOMMENDED_MAIN_MOVIE, movie);
      api.getRecommendations(movie, (movies) => {
        commit(types.SET_RECOMMENDED_MOVIES, movies);
        commit(types.RESET_REQUEST_RECOMMENDED_MOVIES);
      });
    }
  },
  removeRecommendedMovies: ({ commit }) => {
    commit(types.REMOVE_RECOMMENDED_MOVIES);
  },
  increaseRequestedMovies: ({ commit }) => {
    commit(types.INCREASE_REQUEST_RECOMMENDED_MOVIES);
  },
};

const getters = {
  recommendedMovies(state) {
    const end = state.requests * state.block;
    return utils.orderByProperty(state.movies, 'similarity').slice(0, end);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
